export const CATEGORY_LIST = "/examkat";
export const CATEGORY_SUBMIT_ADD = "/examkat/add";
export const CATEGORY_SUBMIT_EDIT = "/examkat/edit";
export const CATEGORY_SUBMIT_STATUS = "/examkat/status/edit";

export const SCHEDULE_LIST = "/exam";
export const SCHEDULE_UPDATE_STATUS = "/exam/edit_status";
export const SCHEDULE_SUBMIT_ADD = "/exam/add";
export const SCHEDULE_SUBMIT_EDIT = "/exam/edit";

export const QUESTION_LIST = "/soal";
export const QUESTION_SUBMIT_ADD = "/soal/add";
export const QUESTION_SUBMIT_EDIT = "/soal/edit";



// WEBPACK FOOTER //
// ./src/views/Exam/endpoints.js